import {FloatPosition, ViewerTool, ViewerToolType} from '../enums';
import {OptValidator, ViewerToolDefinition} from '../types';
import * as PropTypes from 'prop-types';

/**
 * Properties specifické pro mapový zobrazovač.
 */
export interface ViewerProps {
    /**
     * Nástroje dostupné jako plovoucí tlačítka nad mapou.
     */
    tools?: (ViewerTool | ViewerToolDefinition)[];

    /**
     * Nástroje dostupné skrze kontextové menu myši.
     */
    contextTools?: (ViewerTool | ViewerToolDefinition)[];

    /**
     * Příznak, zapínající režim nativního mobilního zobrazení.
     * Výchozí hodnota: `false`.
     */
    nativeMobile?: boolean;
}

/**
 * Typ property definice nástroje zobrazovače.
 *
 * @ignore
 */
const viewerToolDefinitionPropType = PropTypes.exact({
    id: PropTypes.string.isRequired,
    type: PropTypes.oneOf(Object.values(ViewerToolType)).isRequired,
    position: PropTypes.oneOf(Object.values(FloatPosition)) as OptValidator<FloatPosition>,
    icon: PropTypes.string as OptValidator<string>,
    name: PropTypes.string as OptValidator<string>,
    description: PropTypes.string as OptValidator<string>,
    tooltip: PropTypes.string as OptValidator<string>,
});

/**
 * Typ property nástroje zobrazovače.
 *
 * @ignore
 */
const viewerToolPropType = PropTypes.oneOfType([
    PropTypes.oneOf(Object.values(ViewerTool)),
    viewerToolDefinitionPropType,
]);

/**
 * Typy properties specifických pro mapový zobrazovač.
 *
 * @ignore
 */
export const viewerPropTypes = {
    tools: PropTypes.arrayOf(viewerToolPropType.isRequired),
    contextTools: PropTypes.arrayOf(viewerToolPropType.isRequired),
    nativeMobile: PropTypes.bool,
};

/**
 * Výchozí hodnoty properties specifických pro mapový zobrazovač.
 *
 * @ignore
 */
export const viewerDefaultProps = {
    // Zcela záměrně neuvádíme default hodnoty properties, které se synchronizují s mapio.
    // 1) Jsou definovány na straně mapio. Neduplikujeme tím pádem logiku
    //    a neposíláme zbytečné zprávy přes frame.
    // 2) V rámci zpětné kompatibility udržujeme některé deprecated properties.
    //    Default ostatních properties by je mohl přepsat (pokud by šlo o alias).
    debugName: 'MapViewer',
    nativeMobile: false,
};
